import AutomaticReservePrice from "../../../components/view/availability/reservation/automatic-reserve-price";
import FlightCard from "../../../components/common/minimal-flight-card/minimal-flight-card.js";
import BaseTitle from "../../../components/common/base-title/base-title.jsx";
import { ArrowLeft2 } from "iconsax-react";
import { Container, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import SelectedItem from "../../../components/common/selected-item/selected-item.jsx";
import { formatPersianDate } from "../../../utils/date.js";
import { useContext } from "react";
import { LocaleContext } from "../../../routing/LangRouter.js";
import { IS_MOBILE } from "../../../constants/breakpoints.js";

const FlightAutomaticReservationConfirm = ({ selectedTicket }) => {
    const { t } = useTranslation();
    const { locale } = useContext(LocaleContext);

    const generalInformation = JSON.parse(sessionStorage.getItem("generalInformation")) || {};
    const selectedIntFlight = JSON.parse(sessionStorage.getItem("selectedIntFlight")) || {};
    const intFlightInformation = JSON.parse(sessionStorage.getItem("intFlightInformation")) || {};
    const { isFlightInternational } = generalInformation;

    const intFlightData = selectedIntFlight && {
        title: `${t("departureTicket")}  ${intFlightInformation?.returnDate ? t("Flight.And Return") : ""}`,
        name: [
            ...(selectedIntFlight?.segments?.map(segment =>
                locale === "en" ? segment?.departure?.city?.english : segment?.departure?.city?.persian,
            ) ?? []),
            selectedIntFlight?.segments?.[selectedIntFlight?.segments?.length - 1]?.destination?.city?.persian,
        ],
        date: (
            <Grid container item xs={12} direction="column">
                <span>
                    {t("departureDate")}:{" "}
                    {formatPersianDate(selectedIntFlight?.segments?.[0]?.departure_date, {
                        day: "numeric",
                        month: "long",
                        year: undefined,
                        weekday: "long",
                    })}{" "}
                    - {selectedIntFlight?.segments?.[0]?.departure_time.split(":", 2).join(":")}
                </span>
                {intFlightInformation?.returnDate && (
                    <span>
                        {t("returnDate")}:{" "}
                        {formatPersianDate(selectedIntFlight?.return_segments?.[0]?.departure_date, {
                            day: "numeric",
                            month: "long",
                            year: undefined,
                            weekday: "long",
                        })}{" "}
                        - {selectedIntFlight?.return_segments?.[0]?.departure_time.split(":", 2).join(":")}
                    </span>
                )}
            </Grid>
        ),
        type: "intFlight",
        details: selectedIntFlight,
        route: "international-flight",
    };

    return (
        <>
            {selectedTicket && (
                <Container maxWidth="lg">
                    {isFlightInternational ? (
                        <Grid container item mt={IS_MOBILE ? 8 : 0}>
                            <SelectedItem data={intFlightData} />
                        </Grid>
                    ) : (
                        <>
                            <BaseTitle
                                title={
                                    <Grid
                                        container
                                        item
                                        xs={12}
                                        columnGap={1}
                                        pb={2}
                                        sx={{ paddingTop: { xs: 3 } }}
                                        justifyContent="space-between"
                                        alignItems="center"
                                    >
                                        <ArrowLeft2 /> {t("Flight.Your Ticket")}
                                    </Grid>
                                }
                                dividerColor="1px solid var(--medium-gray-color)"
                            />
                            <FlightCard flightItem={selectedTicket} isClickable={false} type="suggest" />
                        </>
                    )}
                </Container>
            )}
            <AutomaticReservePrice />
        </>
    );
};

export default connect(mapStateToProps)(FlightAutomaticReservationConfirm);
function mapStateToProps(state) {
    return {
        selectedTicket: state.selectedTicket,
    };
}
